import React from "react";

export interface YesNoProps {
    value: string | number | undefined | null;
}

export const Value: React.FC<YesNoProps> = ({value}) => {
    return <>{value || '-'}</>;
}